import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ClientMetrics } from '../components/metrics/client-metrics';

interface RouterProps {
    id: string;
}

const ClientMetricsPageComponent = ({ match }: RouteComponentProps<RouterProps>): React.ReactElement => (
    <ClientMetrics clientId={match.params.id} />
);

export const ClientMetricsPage = withRouter(ClientMetricsPageComponent);
